/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { SchemaField, Document, DocumentSchema, SystemFieldType } from '../../../store/models/document.model';
import { DynamicField } from '../dynamic-field';
import { ViewComponent } from '../../../store/models/workflow.model';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { Subject } from 'rxjs';
import { MapLocation } from '@app/modules/map-location-selection/components/select-location-body/select-map-location.models';

@Component({
  selector: 'app-address-field',
  templateUrl: './address-field.component.html',
  styleUrls: ['./address-field.component.scss'],
  standalone: false
})
export class AddressFieldComponent implements DynamicField {
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() field: SchemaField;
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input() document: Document;
  @Input() viewComponent: ViewComponent;
  @Input() dataset: Dataset;
  @Input() schema: DocumentSchema;
  @Input() isEdit: boolean;

  set value(val: string) {
    if (!val) {
      val = '';
    }

    this.address = null;
    this.selectedLocation = null;
    this.selectedFeature = null;
    this._value = val;

    if (!val) {
      this.changeDetector.detectChanges();
      return;
    }
    let parsedObject = null as any;
    try {
      parsedObject = JSON.parse(val);
    } catch (e) {}

    this.selectedFeature = parsedObject;

    this.address = !!this.selectedFeature ? this.selectedFeature?.properties['__address'] : null;
    this.createSelectedLocation();
    this.changeDetector.detectChanges();
  }

  get value(): string {
    if (!this._value) {
      this._value = null;
    }

    return this._value;
  }

  _value: string;
  selectedFeature: GeoJSON.Feature;
  inputHasFocus = false;
  destroy$ = new Subject<void>();
  address: string = null;
  isReadOnly: boolean;
  showLocationSelection: boolean;
  selectedLocation: MapLocation;

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.valueChanged.complete();
  }

  tpOnContentUpdated(): void {
    this.value = this.document?.[this.field.systemName];
    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
    }
  }

  onValueChanged(): void {
    this.valueChanged.emit(this);
  }

  clearLocation() {
    this.address = null;
    this.selectedLocation = {
      position: { lat: null, lng: null },
      viewport: null,
      address: this.address
    };
    this.selectedFeature = null;
    this._value = null;
    this.onValueChanged();

    this.changeDetector.detectChanges();
  }

  private createSelectedLocation(): void {
    let selectedLocation = null;
    if (!!this.selectedFeature) {
      if (this.selectedFeature?.geometry?.type?.toLocaleLowerCase() === 'point') {
        const point = this.selectedFeature.geometry as GeoJSON.Point;
        let viewport = null;
        if (!!this.selectedFeature?.properties['__viewport']) {
          try {
            viewport = JSON.parse(this.selectedFeature?.properties['__viewport']);
          } catch (e) {}
        }
        let zoomLevel = null;
        if (!!this.selectedFeature?.properties['__zoomLevel']) {
          zoomLevel = this.selectedFeature?.properties['__zoomLevel'];
        }
        selectedLocation = {
          position: { lat: point.coordinates[1], lng: point.coordinates[0] },
          viewport: viewport,
          address: this.address,
          zoomLevel: zoomLevel
        };
      }
    }

    this.selectedLocation = selectedLocation;
  }

  setLocationFromMap(): void {
    this.createSelectedLocation();
    this.showLocationSelection = true;
    this.changeDetector.detectChanges();
  }

  saveSelectLocation(location: MapLocation): void {
    if (!!!location?.position) {
      this.showLocationSelection = false;
      return;
    }
    if (!!location?.address) {
      this.address = location?.address;
    }

    this.createSelectedFeature(location);
    this.createSelectedLocation();

    this._value = JSON.stringify(this.selectedFeature);
    this.onValueChanged();

    this.showLocationSelection = false;
  }

  cancelSelectLocation(): void {
    this.showLocationSelection = false;
  }

  private createSelectedFeature(location: MapLocation) {
    this.address = location?.address;
    this.selectedFeature = {
      type: 'Feature',
      properties: {
        '__address': this.address,
        '__viewport': !!location?.viewport ? JSON.stringify(location?.viewport) : null,
        '__zoomLevel': location?.zoomLevel
      },
      bbox: !!location?.viewport
        ? [
            location?.viewport.getSouthWest().lng(),
            location?.viewport.getSouthWest().lat(),
            location.viewport.getNorthEast().lng(),
            location.viewport.getNorthEast().lat()
          ]
        : null,
      geometry: {
        type: 'Point',
        coordinates: [location?.position?.lng, location?.position?.lat]
      }
    } as GeoJSON.Feature;
  }

  onSearchResultChanged(location: MapLocation) {
    this.createSelectedFeature(location);
    this._value = JSON.stringify(this.selectedFeature);
    this.onValueChanged();
  }
}
